import React from "react";
import Aux from "../utils/AuxFunctions";
import "./Account.css"
import Fire from "../config/Fire";
import { withMyDataContext } from "../context/DataProvider";
import ErrorMessage from "../utils/ErrorPages/ErrorMessage";
import ButtonLoader from "../utils/Utilities/ButtonLoader";
import Colors from "../utils/Colors";
import NotLoggedIn from "../utils/ErrorPages/NotLoggedIn";
import moment from "moment"
import CongratulationsModal from "../utils/Utilities/CongratulationsModal";
import CheckCircleOutlineIcon from "mdi-react/CheckIcon";
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import LoadingHelper from "../utils/Utilities/LoadingHelper";

const allDailyRewards = [
    { day: 1, reward: 1, state: false },
    { day: 2, reward: 1, state: false },
    { day: 3, reward: 1, state: false },
    { day: 4, reward: 2, state: false },
    { day: 5, reward: 2, state: false },
    { day: 6, reward: 5, state: false },
]

class DailyRewards extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dailyRewards: allDailyRewards,
            isClaiming: false,
            congratulationsModal: false,
            moneyEarned: 0,
            error: "",
            sucess: false,
        }
    }

    componentDidMount = () => {
        try{
            this.props.myDataProvider.setNewDailyReward(false)
        }catch(error){
            Aux.handleError(error)
        }
    }

    getTime = (date) => {
        try {
            if (date) {

                var time = moment(date).unix()
                
                return time || "error";
            } else {
                return "error"
            }
        } catch (error) {
            Aux.handleError(error)
        }
    }

    OnClaimReward = async (day, reward) => {
        if (this.state.isClaiming)
            return;

        try {
            this.setState({ isClaiming: true, error: "" })
            const isLastDay = day === allDailyRewards.length
            await Fire.shared.claimDailyReward(day + 1, reward, isLastDay)
                .then((gotRewarded) => {
                    if (gotRewarded) {
                        this.setState({ congratulationsModal: true, moneyEarned: reward, alreadyGotReward: true })
                    } else {
                        this.setState({ error: "An error has occurred" })
                    }
                })
            this.setState({ isClaiming: false })
        } catch (error) {
            Aux.handleError(error)
            this.setState({ isClaiming: false, error: "An error has occurred" })
        }
    }

    closeModal = () => {
        this.setState({ congratulationsModal: !this.state.congratulationsModal, })
    }

    goBack = () => {
        try {
            this.props.history.push("/account/settings")
        } catch (error) {
            Aux.handleError(error)
        }
    }


    SingleDailyReward = (reward) => {
        // let reward = allDailyRewards[id]; 

        if ((this.props.myDataProvider.user.lastDayReward === 0 || !this.props.myDataProvider.user.lastDayReward) && reward.day === 1) {
            reward.state = "claim";
            

        } else if (this.props.myDataProvider.user.lastDayReward === reward.day) {
            if (this.props.myDataProvider.user.lastTimestamp) {
                let previousDate = this.getTime(this.props.myDataProvider.user.lastTimestamp.toDate()) + 24*60*60 //(24*60*60)
                if (this.props.myDataProvider.currentTimestamp > previousDate) {
                    reward.state = "claim"
                    //Fire.shared.setNewTimeStamp();
                } else {
                    reward.state = "unavailable";
                }

            }
            
        } else if (this.props.myDataProvider.user.lastDayReward < reward.day) {
            reward.state = "unavailable"
        } else if (this.props.myDataProvider.user.lastDayReward) {
            //reward.state = "rewarded"
            reward.state = "rewarded"
        } else {
            reward.state = "unavailable"
        }
        let isComplete = reward.state === "claim"
        let alreadyRewarded = reward.state === "rewarded"
        return (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems:"center", margin: "10px 10px", padding:"10px 20px", 
                borderWidth: isComplete ? 1 : 0, borderStyle: "solid", borderColor: "#777", borderRadius:10 }}>

                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{
                        display: "flex", borderRadius: "50%", height: 50, width: 50, borderWidth: 3,
                        borderColor: isComplete ? Colors.mainColor : alreadyRewarded ? Colors.green : Colors.mainColor,
                        backgroundColor: isComplete ? Colors.mainColor : alreadyRewarded ? Colors.green : "white",
                        color: isComplete ? "white" : alreadyRewarded ? "white" : "black",
                        justifyContent: "center", alignItems: "center", borderStyle: "solid"
                    }}>
                        {alreadyRewarded ?
                            <CheckCircleOutlineIcon></CheckCircleOutlineIcon> :
                            <span style={{ fontWeight: "bold", fontSize: 13 }}>Day {reward.day}</span>}
                    </div>
                    <div style={{ display: "flex", marginLeft: 20, alignItems: "center" }}>
                        <span style={{ color: Colors.green, fontWeight: "bold", fontSize: 15 }}>Reward:</span>
                        <h4 style={{ marginLeft: 10, color: Colors.darkText, fontWeight: "bold", fontSize: 18 }}>{reward.reward}$</h4>
                    </div>
                </div>
                {reward.state === "claim" ? (
                    <ButtonLoader
                        text="Claim"
                        loading={this.state.isClaiming}
                        onClick={() => this.OnClaimReward(reward.day, reward.reward)}
                        style={{ backgroundColor: Colors.mainColor, height: 45, minWidth: 100, width: 100, margin: 0, borderRadius: 10 }}
                    />
                ) : reward.state === "unavailable" ?
                        <ButtonLoader
                            text="Claim"
                            disabled={true}
                            style={{ backgroundColor: "lightgrey", height: 45, minWidth: 100, width: 100, borderRadius: 10, margin: 0 }}
                        />

                        : (
                            <div style={{ borderRadius: 15, height: 45, width: 100, justifyContent: "center", alignSelf: "flex-end", borderWidth: 3, borderColor: Colors.mainColor }}>
                                {/* <div style={{color: Colors.mainColor, fontSize:16, alignSelf:"center", fontWeight:"bold"}}>
                        rewarded
                    </div> */}
                            </div>

                        )}
            </div>
        )
    }

    goBack = () => {
        try {
            this.props.history.goBack()
        } catch (error) {
            Aux.handleError(error)
        }
    }

    render() {

        return (
            <div style={{ width: "100%" }}>
                <CongratulationsModal active={this.state.congratulationsModal} onClose={this.closeModal} coins={this.state.moneyEarned}></CongratulationsModal>
                <NotLoggedIn active={this.state.loginDialog} onClose={() => this.setState({ loginDialog: false })}></NotLoggedIn>
                <section className="container login">
                    <div className="reversed-button-hover" style={{display:"flex", alignItems:"center", marginBottom:20}} onClick={this.goBack}>
                        <ChevronLeftIcon style={{marginRight:5}}></ChevronLeftIcon>
                        <h2>Daily Rewards</h2>
                    </div>
                    {/* <span>Did you forgot your password?  </span> */}
                    <ErrorMessage text={this.state.error}></ErrorMessage>
                    {this.props.myDataProvider.user ?
                        this.props.myDataProvider.currentTimestamp ?
                            <div>
                                {this.state.dailyRewards.map((daily, index) => {
                                    return <div key={index}>{this.SingleDailyReward(daily)}</div>
                                })}
                            </div>
                            : <div style={{marginTop:10}}>
                                <span>We couldn't get the current time</span>
                                <ButtonLoader
                                    text="Try Again"
                                    style={{ backgroundColor: Colors.mainColor, padding: "12px 20px", width: "90%", marginTop: 10 }}
                                    onClick={() => this.props.myDataProvider.getServerTimestamp()}
                                />

                            </div>
                        :
                        <LoadingHelper/>
                    }

                </section>
                {/* <ButtonLoader
                    text="Back"
                    icon={ChevronLeftIcon}
                    style={{ backgroundColor: "#ccc", margin: "0 20px" }}
                    onClick={this.goBack}
                >
                </ButtonLoader> */}
            </div>
        );
    }
}

export default withMyDataContext(DailyRewards);